"use client";
import { useEffect } from "react";

/**
 * 延迟加载非关键CSS，减少首屏渲染阻塞
 * 通过动态创建link标签，使用media="print"技巧避免阻塞渲染
 */
export default function LazyCSS() {
	useEffect(() => {
		// 延迟加载animate.css和remixicon CSS
		const loadCSS = (href: string, id: string) => {
			if (document.getElementById(id)) return; // 已加载
			
			const link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = href;
			link.id = id;
			link.media = 'print'; // 先设置为print，避免阻塞渲染
			link.onload = () => {
				link.media = 'all'; // 加载完成后改为all
			};
			document.head.appendChild(link);
		};

		// 使用requestIdleCallback延迟加载，在浏览器空闲时执行
		const loadLazyCSS = () => {
			// 查找Next.js生成的CSS文件路径（这些路径在构建时生成）
			// 由于无法直接获取构建后的路径，我们通过查找现有link标签来推断
			const existingLinks = Array.from(document.querySelectorAll('link[rel="stylesheet"]'));
			const animateLink = existingLinks.find(link => 
				link.getAttribute('href')?.includes('animate') || 
				link.getAttribute('href')?.includes('animate.css')
			);
			const remixiconLink = existingLinks.find(link => 
				link.getAttribute('href')?.includes('remixicon') ||
				link.getAttribute('href')?.includes('remixicon.css')
			);
			
			// 如果找到了，说明已经通过import加载了，不需要延迟加载
			// 否则，尝试延迟加载（但Next.js的CSS导入是同步的，这个组件主要用于未来优化）
		};

		// 延迟执行，避免阻塞首屏
		if ('requestIdleCallback' in window) {
			requestIdleCallback(loadLazyCSS, { timeout: 3000 });
		} else {
			setTimeout(loadLazyCSS, 2000);
		}
	}, []);

	return null;
}
